/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewcolumnheld3Inputs */

const en_sharereviewcolumnheld3 = /** @type {(inputs: Sharereviewcolumnheld3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Held`)
};

const de_sharereviewcolumnheld3 = /** @type {(inputs: Sharereviewcolumnheld3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückgehalten`)
};

/**
* | output |
* | --- |
* | "Held" |
*
* @param {Sharereviewcolumnheld3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewcolumnheld3 = /** @type {((inputs?: Sharereviewcolumnheld3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewcolumnheld3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewcolumnheld3(inputs)
	return de_sharereviewcolumnheld3(inputs)
});
export { sharereviewcolumnheld3 as "shareReviewColumnHeld" }